/*Package importing*/
import React from 'react';

/*Import custom components and assets*/

const H1 = ({ headOne, headTwo }) => {
  return (
    <h1 className="pb-4">{headOne} <b>{headTwo}</b></h1>
  );
};

export default H1;
